import Input3 from './Input3'

export default Input3;